"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
exports.default = (0, vue_1.defineComponent)({
    name: 'Party',
    props: {
        party: {
            type: Object,
            required: true,
        },
        isDominant: {
            type: Boolean,
        },
        isAvailable: {
            type: Boolean,
        },
    },
    methods: {
        partyNameToCss(party) {
            if (party === undefined) {
                console.warn('no party provided');
                return '';
            }
            return party.toLowerCase().split(' ').join('_');
        },
        getDominantClass() {
            return 'select-party-leader-spot' + (this.isDominant ? ' dominance-marker' : '');
        },
        getUnavailablePartyClass() {
            return this.isAvailable ? '' : ' unavailable-party';
        },
    },
});
